import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { RouterOutlet } from '@angular/router';
import { NoInternetService, ToastContainerComponent } from 'nexus-core';
import { RouteValidatorService } from './common/route-validator.service';
import { environment } from '../environments/environment';
import { connectFunctionsEmulator, Functions } from '@angular/fire/functions';

@Component({
    selector: 'nexus-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastContainerComponent]
})
export class AppComponent {
  constructor(
    readonly noInternetService: NoInternetService,
    readonly screenTrackingService: ScreenTrackingService,
    readonly routeValidatorService: RouteValidatorService,
    private readonly functions: Functions,
  ) {
    if(environment.useEmulatedFunctions) {
      connectFunctionsEmulator(this.functions, "127.0.0.1", 5001);
    }
  }
}
